'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--SpotifyWithCircle';

var EntypoSpotifyWithCircle = function EntypoSpotifyWithCircle(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6s9.6-4.298,9.6-9.6S15.302,0.4,10,0.4z M12.964,13.837c-0.148,0-0.25-0.056-0.359-0.122c-1.013-0.613-2.268-0.935-3.628-0.935c-0.694,0-1.443,0.082-2.226,0.242l-0.095,0.024c-0.1,0.024-0.201,0.05-0.279,0.05c-0.315,0-0.562-0.245-0.562-0.559c0-0.318,0.18-0.543,0.479-0.6c0.934-0.213,1.814-0.316,2.687-0.316c1.58,0,2.994,0.365,4.201,1.09c0.208,0.121,0.338,0.26,0.338,0.569C13.519,13.588,13.271,13.837,12.964,13.837z M13.742,11.654c-0.177,0-0.292-0.067-0.395-0.127c-1.825-1.084-4.547-1.443-6.785-0.847c-0.037,0.011-0.07,0.021-0.102,0.031c-0.084,0.027-0.164,0.053-0.274,0.053c-0.368,0-0.667-0.301-0.667-0.672c0-0.357,0.186-0.607,0.524-0.702c0.862-0.236,1.674-0.393,2.84-0.393c1.886,0,3.714,0.473,5.146,1.33c0.261,0.148,0.379,0.353,0.379,0.658C14.408,11.355,14.109,11.654,13.742,11.654z M14.625,9.166c-0.166,0-0.269-0.039-0.421-0.123c-1.239-0.744-3.171-1.186-5.174-1.186c-1.043,0-1.99,0.115-2.817,0.338C6.185,8.202,6.158,8.21,6.13,8.219C6.042,8.245,5.932,8.277,5.818,8.277c-0.439,0-0.783-0.348-0.783-0.792c0-0.386,0.217-0.681,0.579-0.788c0.998-0.295,2.148-0.443,3.415-0.443c2.281,0,4.453,0.506,5.957,1.391c0.284,0.16,0.423,0.404,0.423,0.742C15.409,8.823,15.064,9.166,14.625,9.166z' })
    );
};

exports.default = EntypoSpotifyWithCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-entypo-icons/lib/entypo/SpotifyWithCircle.js
// module id = 7525
// module chunks = 0